<template>
  <div id="userInfo">
    <el-tabs v-model="activeName" class="demo-tabs">
      <!-- 个人资料 -->
      <el-tab-pane label="个人资料" name="info">
        <el-form
          style="max-width: 500px"
          :model="form"
          label-width="auto"
          label-position="top"
        >
          <el-form-item label="姓名">
            <el-input
              v-model="form.realname"
              placeholder="请输入姓名"
              clearable
            />
          </el-form-item>
          <el-form-item label="省市区" label-width="120px">
            <el-cascader
              v-model="districtValue"
              :options="district"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item label="QQ">
            <el-input v-model="form.qq" placeholder="请输入QQ" clearable />
          </el-form-item>
          <el-form-item label="Email">
            <el-input
              v-model="form.email"
              placeholder="请输入Email"
              clearable
            />
          </el-form-item>
          <el-form-item label="公司名称">
            <el-input
              v-model="form.company"
              placeholder="请输入公司名称"
              clearable
            />
          </el-form-item>
          <el-form-item label="企业详细地址">
            <el-input
              :autosize="{ minRows: 2, maxRows: 4 }"
              type="textarea"
              maxlength="30"
              show-word-limit
              v-model="form.address"
              placeholder="请输入企业详细地址"
              clearable
            />
          </el-form-item>

          <div class="bottom">
            <el-button type="primary" size="large" @click="userInfoSet"
              >保存</el-button
            >
          </div>
        </el-form>
      </el-tab-pane>
      <!-- 修改密码 -->
      <el-tab-pane label="修改密码" name="password">
        <el-form
          style="max-width: 500px"
          :model="form2"
          label-width="auto"
          label-position="top"
        >
          <el-form-item label="用户名">
            <el-input
              v-model="form2.name"
              placeholder="请输入用户名"
              clearable
              disabled
            />
          </el-form-item>
          <el-form-item label="旧密码">
            <el-input
              v-model="form2.old_passwd"
              placeholder="请输入旧密码"
              clearable
            />
          </el-form-item>
          <el-form-item label="新密码">
            <el-input
              v-model="form2.passwd"
              placeholder="请输入新密码"
              clearable
            />
          </el-form-item>
          <div class="bottom">
            <el-button type="primary" size="large" @click="accountSet"
              >保存</el-button
            >
          </div>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script setup>
import {
  reactive,
  ref,
  getCurrentInstance,
  onMounted,
  watch,
  nextTick,
  onActivated,
  inject,
} from "vue";
import { useStore } from "vuex";
import { ElMessage, ElMessageBox } from "element-plus";
import Province from "@/utils/full-citys.js";
import md5 from "js-md5";
//获取公共方法
let { proxy } = getCurrentInstance();
//全局数据
let vuex = useStore();
//标签页名称
let activeName = ref("info");
//用户信息表单数据
let form = reactive({
  realname: "",
  country: 0,
  prov: 0,
  city: 0,
  area: 0,
  address: "",
  qq: "",
  email: "",
  company: "",
});
//账号表单数据
let form2 = reactive({
  name: "",
  old_passwd: "",
  passwd: "",
});
//地区数据
let district = ref([]);
//地区值
let districtValue = ref([]);
//监听省市区变化
watch([() => districtValue.value], async (newValue, oldValue) => {
  let indexArr = newValue[0];
  if (indexArr.length > 0) {
    form.prov = district.value[indexArr[0]].value;
    form.city = district.value[indexArr[0]].children[indexArr[1]].value;
    form.area =
      district.value[indexArr[0]].children[indexArr[1]].children[
        indexArr[2]
      ].value;
  }
});
//页面渲染事件
onMounted(() => {
  userInfoGet();
  getRegionData();
});
// 加载省市区数据
const getRegionData = () => {
  const arr = [];
  const provinces = Province.getProvs();
  for (let prov of provinces) {
    const item = { label: prov.name, value: prov.id };
    const cities = Province.getCitys(prov.id);
    item.children = [];
    for (let city of cities) {
      const cityItem = { label: city.name, value: city.id };
      const areas = Province.getAreas(prov.id, city.id);
      cityItem.children = [];
      for (let area of areas) {
        const areaItem = { label: area.name, value: area.id };
        cityItem.children.push(areaItem);
      }
      if (!cityItem.children.length)
        Reflect.deleteProperty(cityItem, "children");
      item.children.push(cityItem);
    }
    arr.push(item);
  }
  console.log(arr);
  district.value = arr;
};
// 编辑时初始化省市区
const setDefaultRegion = () => {
  const ruleFormData = ruleForm.value,
    values = [];
  if (ruleFormData.prov !== undefined) values.push(ruleFormData.prov);
  if (ruleFormData.prov !== undefined && ruleFormData.city !== undefined)
    values.push(ruleFormData.city);
  if (
    ruleFormData.prov !== undefined &&
    ruleFormData.city !== undefined &&
    ruleFormData.area !== undefined
  )
    values.push(ruleFormData.area);
  ruleFormData.regionValues = values;
  ruleForm.value = ruleFormData;
  regionValues.value = values;
};
//用户信息获取
function userInfoGet() {
  proxy.$http
    .get("webapi/myaccount?item=get", {
      params: {},
    })
    .then(({ data: res }) => {
      if (res.code == 0) {
        form2.name = res.data.name || "";
        form.realname = res.data.realname || "";
        form.country = res.data.country || 0;
        form.prov = res.data.prov || 0;
        form.city = res.data.city || 0;
        form.area = res.data.area || 0;
        form.address = res.data.address || "";
        form.qq = res.data.qq || "";
        form.email = res.data.email || "";
        form.company = res.data.company || "";
        let provIndex = 0,
          cityIndex = 0,
          areaIndex = 0;
        provIndex = district.value.findIndex((item) => item.value == form.prov);
        districtValue.value[0] = provIndex;
        cityIndex = district.value[provIndex].children.findIndex(
          (item) => item.value == form.city
        );
        districtValue.value[1] = cityIndex;
        areaIndex = district.value[provIndex].children[
          cityIndex
        ].children.findIndex((item) => item.value == form.area);
        districtValue.value[2] = areaIndex;
        console.log(districtValue.value);
      }
    })
    .catch((err) => {
      console.log("用户信息获取请求失败");
    });
}
//用户信息编辑
function userInfoSet() {
  if (!form.realname) {
    return ElMessage({
      message: `姓名不能为空`,
      type: "warning",
    });
  }
  proxy.$http
    .post("webapi/myaccount?item=set", {
      ...form,
    })
    .then(({ data: res }) => {
      if (res.code == 0) {
        if (res.code == 0) {
          ElMessage({
            message: `编辑成功！`,
            type: "success",
          });
          vuex.commit("setUser", { realname: form.realname });
        } else {
          ElMessage({
            message: `编辑失败！`,
            type: "error",
          });
        }
      }
    })
    .catch((err) => {
      console.log("用户信息编辑请求失败");
    });
}
//账号编辑
function accountSet() {
  if (!form2.old_passwd) {
    return ElMessage({
      message: `旧密码不能为空`,
      type: "warning",
    });
  }
  if (!form2.passwd) {
    return ElMessage({
      message: `新密码不能为空`,
      type: "warning",
    });
  }
  proxy.$http
    .post("webapi/myaccount?item=set", {
      old_passwd:md5(`mq${form2.name}${form2.old_passwd}`),
      passwd:md5(`mq${form2.name}${form2.passwd}`),
    })
    .then(({ data: res }) => {
      if (res.code == 0) {
        if (res.code == 0) {
          ElMessage({
            message: `编辑成功！`,
            type: "success",
          });
          form2.old_passwd=""
          form2.passwd=""
        } else {
          ElMessage({
            message: `编辑失败！`,
            type: "error",
          });
        }
      }
    })
    .catch((err) => {
      console.log("用户信息编辑请求失败");
    });
}
</script>

<style lang="scss" scoped>
@import "@/assets/css//userInfo.scss";
</style>